
  import { defineComponent, toRefs } from 'vue';
  import { DropdownField } from '@/ui/components/form';
  import { DueAfterSelection } from '@/ui/components/issueTemplate/issueCreateTemplateModal/DueAfterSelection';
  import { ChecklistTemplateEditable } from '@/ui/DTO';
  import { ValidationError } from '@/entities/validation';
  import { SelectOptions } from '@/ui/types';
  import AssigneesField from '@/ui/pages/user/assignees/AssigneesField.vue';
  import { DueAfter } from '@/entities/checklistTemplate';
  import { Field } from '@/ui/components/form/Field';

  export default defineComponent({
    name: 'ChecklistTemplateForm',
    components: {
      DropdownField,
      DueAfterSelection,
      AssigneesField,
      Field,
    },
    props: {
      record: { type: Object as () => ChecklistTemplateEditable, required: true },
      assigneeOptions: { type: Array as () => SelectOptions, required: true },
      checklists: { type: Array as () => SelectOptions, required: true },
      validationErrors: { type: Array as () => ValidationError[], required: true },
    },
    emits: ['update-user-options'],
    setup(props, { emit }) {
      const { record, checklists } = toRefs(props);

      const onChecklistChange = (value: string | number) => {
        const opt = checklists.value.find(c => c.value === value);
        record.value.checklistId = value ? Number(value) : null;
        record.value.title = opt ? opt.label : '';
      };

      const onAssigneesChange = (value: Array<string | number>) => {
        const assignees: string[] = [];
        const assignedGroups: string[] = [];

        value.forEach(v => {
          const s = String(v);
          if (s.includes('user_')) {
            assignees.push(s);
          } else if (s.includes('group_')) {
            assignedGroups.push(s);
          }
        });

        record.value.assignees = assignees;
        record.value.assignedGroups = assignedGroups;
      };

      const updateUserOptions = () => {
        emit('update-user-options');
      };

      const updateDueIn = (value: DueAfter) => {
        record.value.dueIn = value;
      };

      return {
        onChecklistChange,
        onAssigneesChange,
        updateUserOptions,
        updateDueIn,
      };
    },
  });
